import React, { useEffect, useState } from "react";
import { ListGroup, Table } from "react-bootstrap";
import {
  getTasks,
  postTasks,
  deleteRoadMapService,
} from "../../services/tasks/tasks";
import { FaTrash, FaEdit, FaEye } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import styles from "./admin.module.scss";
import "./styles.css";

export default function Admin() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [taskText, setTastText] = useState("");
  const [tasks, setTasks] = useState([]);
  const [apiTasks, setApiTasks] = useState([]);
  const [state, setState] = useState(false);
  const notify = () => toast.success("Task Added");
  const handleSubmit = (e) => {
    e.preventDefault();

    setTitle("");
    setDescription("");
    setTastText("");
  };

  useEffect(() => {
    getAllTasks();
  }, [state]);

  const getAllTasks = () => {
    getTasks()
      .then((res) => {
        console.log(res);
        setApiTasks(res?.data);
      })
      .catch((e) => {
        console.error("Err :", e);
      });
  };

  const addTask = () => {
    let arr = tasks;
    arr.push(taskText);
    setTasks(arr);
    setTastText("");
  };

  const saveTasks = () => {
    let payload = { tasks: tasks, title: title, description: description };
    postTasks(payload)
      .then((res) => {
        setState(true);

        console.log("res : ", res);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const deletTasks = () => {
    <button
      onClick={() => {
        deletTasks();
      }}
    >
      delet
    </button>;

    // let payload = { tasks: tasks, title: title, description: description }
    // postTasks(payload).then(res => { console.log("res : ", res) }).catch(e => { console.error(e) })
  };

  const deleteRoadMap = (id) => {
    deleteRoadMapService(id)
      .then((res) => {
        console.log("res : ", res);
        getAllTasks();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  let navigate = useNavigate();

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="deal">
          <h4 className="h">Admin panel</h4>
          <div className="inpu">
            <input
              className="div"
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              value={title}
              placeholder="Title"
            />
            <br></br>
          </div>
          <div className="inpu">
            <input
              className="div"
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              value={description}
              placeholder="Description"
            />
            <br></br>
          </div>

          <input
            className="div"
            onChange={(e) => {
              setTastText(e.target.value);
            }}
            value={taskText}
            placeholder="Task Name"
          />
          {/* <button className='btun' onClick={() => { addTask() }} >Add Field</button><br></br> */}

          <ListGroup as="ol" numbered>
            {tasks.map((item) => (
              <ListGroup.Item as="li" className="add">
                {" "}
                {item}{" "}
                <button className=" stg btn btn-primary offset-lg-8 ">
                  Delete{" "}
                </button>{" "}
              </ListGroup.Item>
            ))}
          </ListGroup>

          <button
            type="submit"
            onClick={() => {
              saveTasks();
              notify();
            }}
            className="save"
          >
            Save
          </button>
          {/* <button onClick={() => { deletTasks() }}>Delete</button> */}
        </div>
        <ToastContainer />
      </form>

      <div className="mt-4">
        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Description</th>
              <th>Author</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {apiTasks &&
              apiTasks?.map((item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>{item?.description}</td>
                  <td>{item?.author}</td>
                  <td className={styles.actions_container}>
                    <FaTrash
                      onClick={() => {
                        deleteRoadMap(item.id);
                      }}
                      className={styles.icon}
                    />
                    <FaEye
                      className={styles.icon}
                      onClick={() => navigate(`../roadmaps/${item.id}`)}
                    />
                    <FaEdit className={styles.icon} />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
